import type { FaireProductEntity } from "../../entity_types/product";

export const p_wsmhm83tj8: FaireProductEntity = {
  token: "p_wsmhm83tj8",
  type: "product",
  name: "Sk8er Girl Checkered Huggies",
  brandToken: "b_2awlua1ssd",
  brandName: "Golden Hour Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/ca8a76af21cab4d36b6b941607563b19fe4261c85f60e73534269cfd387acd04.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5835808ce292c3d626854f55baba74694d35bdc524a8e853b7542c7cc74d519d.jpeg",
    "https://cdn.faire.com/fastly/0b80ea01a0e0dabd072e44d08574c75f29c17dc7f2d03fcbc21a55676ae9b283.jpeg",
    "https://cdn.faire.com/fastly/940fea518a8db481ce0891f9e7802bae7a5b8f0eb9aa452d5d74ca242b6c3562.jpeg",
    "https://cdn.faire.com/fastly/88bc0358244767c2f34198d10df33807dbc51e645b7903eba7cde185c8094bff.jpeg",
    "https://cdn.faire.com/fastly/6a09a8b230bd344bba9bc898213d3bf4f85b9a78864673448ce22348935913e0.jpeg",
    "https://cdn.faire.com/fastly/6197fd6b43835a18c52bc177568babc6c55ac4915ec5832ed8fe3156885f2b73.jpeg",
    "https://cdn.faire.com/fastly/7cf530721bb3232893619a7f2e97bb5728e95822790f20d38301553297302789.jpeg",
    "https://cdn.faire.com/fastly/825b8db83f5db3fa2617eccfb3f2fbde1407d99b1ca90992654d568494118016.jpeg",
  ],
  priceDollars: 13,
  description:
    "Rock the raddest style with our Sk8er Girl Silver Checkered Huggies! These metal and enamel earrings feature a checker pattern in classic black and white. Perfect for adding some edgy flair to any outfit. — MATERIALS — All items are made with love in Sacramento, CA. Earrings come on our plated earring findings that are simple, lightweight, and super comfy for all-day wear. \n\n— DIMENSIONS —\n\n0.5 X 0.5 INCHES\n\n— CARE —\n\nWe recommend removing jewelry before showering, swimming or sleeping to extend their shiny, wearable life. Scratches may occur during wear so be sure to keep them in a safe, dry place when not sporting them.\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:40.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
